import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

const numericRegExAccNo = /^[0-9]{10}$/;
const numericRegExSSN = /^[0-9]{4}$/;

export const GetCustomerLoginFormSchema = (intl: IntlShape) => Yup.object({
  accountNumber: Yup.string()
    .min(10, intl.formatMessage({ id: 'customer-login-validation.accNo-digits' }))
    .max(10, intl.formatMessage({ id: 'customer-login-validation.accNo-digits' }))
    .matches(numericRegExAccNo, intl.formatMessage({ id: 'customer-login-validation.accNo-numeric' }))
    .required(intl.formatMessage({ id: 'customer-login-validation.accNo-required' })),

  ssn4: Yup.string()
    .min(4, intl.formatMessage({ id: 'customer-login-validation.SSN-digits' }))
    .max(4, intl.formatMessage({ id: 'customer-login-validation.SSN-digits' }))
    .matches(numericRegExSSN, intl.formatMessage({ id: 'customer-login-validation.SSN-numeric' }))
    .required(intl.formatMessage({ id: 'customer-login-validation.SSN-required' })),
});

export const GetCustomerLoginFormInitialValue = (): ICustomerLoginFormFields => ({
  accountNumber: '',
  ssn4: '',
});

export interface ICustomerLoginFormFields {
  accountNumber: string;
  ssn4: string;
}
